// TelcoTrack — Zařízení route guard.
// Saved profile `sections.equipment.view` (chip Zařízení — číst). Role alone does not open the page.

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { canViewEquipmentSection } from '@core/shared-bridge';
import { EQUIPMENT_HUB_UI_ENABLED } from '../../features/equipment/equipment-hub.flags';

export const equipmentGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  if (!EQUIPMENT_HUB_UI_ENABLED) {
    return router.createUrlTree(['/materials', 'warehouse', 'stock']);
  }
  const user = authService.getCurrentUser();
  if (canViewEquipmentSection(authService.getSessionRoles(), user?.permissionProfile)) {
    return true;
  }
  return router.createUrlTree(['/403']);
};
